module.exports = __webpack_public_path__ + "img/barspondinfo.7235495c.svg";